var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgScheduleTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3333 10.7223H10.6667C9.43936 10.7223 8.44443 11.7172 8.44443 12.9445V20.9445C8.44443 22.1718 9.43935 23.1667 10.6667 23.1667H21.3333C22.5606 23.1667 23.5555 22.1718 23.5555 20.9445V12.9445C23.5555 11.7172 22.5606 10.7223 21.3333 10.7223ZM10.6667 9.38892C8.70298 9.38892 7.1111 10.9808 7.1111 12.9445V20.9445C7.1111 22.9082 8.70298 24.5 10.6667 24.5H21.3333C23.297 24.5 24.8889 22.9082 24.8889 20.9445V12.9445C24.8889 10.9808 23.297 9.38892 21.3333 9.38892H10.6667Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4444 7.83334C12.8126 7.83334 13.1111 8.13181 13.1111 8.5V9.38889C13.1111 9.75708 12.8126 10.0556 12.4444 10.0556C12.0762 10.0556 11.7778 9.75708 11.7778 9.38889V8.5C11.7778 8.13181 12.0762 7.83334 12.4444 7.83334Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5556 7.83334C19.9237 7.83334 20.2222 8.13181 20.2222 8.5V9.38889C20.2222 9.75708 19.9237 10.0556 19.5556 10.0556C19.1874 10.0556 18.8889 9.75708 18.8889 9.38889V8.5C18.8889 8.13181 19.1874 7.83334 19.5556 7.83334Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7427 12.9444H12.2573C11.8737 12.9444 11.5556 13.2466 11.5556 13.6111C11.5556 13.9755 11.8737 14.2778 12.2573 14.2778H19.7427C20.1263 14.2778 20.4444 13.9755 20.4444 13.6111C20.4444 13.2466 20.1263 12.9444 19.7427 12.9444Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleTime);
export default __webpack_public_path__ + "static/media/scheduleTime.29132489.svg";
export { ForwardRef as ReactComponent };